<template>
  <floating-menu
    v-if="editor"
    :editor="editor"
    :tippy-options="{
      duration: 100,
      placement: 'left',
      offset: [0, 3],
    }"
    ref="floatingMenu"
  >
    <editor-menu
      :items="nodesButtons"
      v-model="floatingAddMenuIsOpen"
      @click.native="editor.view.focus()"
      close-on-content-click
      hide-current-active
    >
      <template #activator="{ on }">
        <v-btn
          x-small
          color="grey"
          class="pa-0"
          style="min-width: 18px; height: 18px"
          v-on="on"
          outlined
          v-tooltip="$t('textEditor.lineMenu.tooltip')"
        >
          <v-icon x-small>
            mdi-plus
          </v-icon>
        </v-btn>
      </template>
    </editor-menu>
    <v-menu
      v-model="createTableDialog"
      offset-y
      nudge-bottom="5px"
    >
      <template #activator="{ on }">
        <div />
      </template>
      <v-card>
        <table-creator
          class="pa-2"
          @create-table="createTable"
        />
      </v-card>
    </v-menu>
  </floating-menu>
</template>

<script>
import { ref, inject, watch } from "vue"
import { FloatingMenu } from "@tiptap/vue-2"
import EditorMenu from "./editor_menu.vue"
import TableCreator from "./table_creator.vue"
import useTextEditorButtons from "./useTextEditorButtons"
import { useElementVisibility, watchPausable } from "@vueuse/core"

export default {
  name: "TextEditorFloatingMenu",
  components: {
    FloatingMenu,
    EditorMenu,
    TableCreator,
  },
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    featureTable: {
      type: Boolean,
      default: true,
    },
    featureMath: {
      type: Boolean,
      default: true,
    },
    featureCode: {
      type: Boolean,
      default: true,
    },
  },

  setup(props) {
    const createTableDialog = ref(false)
    const floatingAddMenuIsOpen = ref(false)

    const editor = inject("editor")


    const floatingMenu = ref(null)
    const isVisible = useElementVisibility(floatingMenu)

    const { nodesButtons } = useTextEditorButtons(editor, {
      featureTable: props.featureTable,
      featureMath: props.featureMath,
      featureCode: props.featureCode,
      createTableDialog,
    })

    const debouncedNodesButtons = ref([])

    const { pause, resume } = watchPausable(nodesButtons, (v) => debouncedNodesButtons.value = v)

    watch(isVisible, (v) => v ? resume() : pause())


    const createTable = ({ rows, cols }) => {
      editor
        .value
        .chain()
        .focus()
        .insertTable({ rows, cols, withHeaderRow: true })
        .run()
    }

    return {
      nodesButtons: debouncedNodesButtons,
      createTableDialog,
      floatingAddMenuIsOpen,
      editor,
      floatingMenu,
      isVisible,
      createTable,
    }
  },
}
</script>
